import { useAuth } from '@berky/auth'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { useFeedbackApi } from './feedback-api'

export interface FeedbackCategory {
  id: string
  name: string
  icon: string
  enabled: boolean
}

export interface FeedbackSettings {
  generalIdeaEnabled: boolean
  version: string
  categories: FeedbackCategory[]
}

export const feedbackIconOptions = [
  { value: 'Database', label: 'Datenbank' },
  { value: 'FileSpreadsheet', label: 'Tabelle' },
  { value: 'FileText', label: 'Dokument' },
  { value: 'Wrench', label: 'Werkzeug' },
  { value: 'Building2', label: 'Gebäude' },
  { value: 'Printer', label: 'Drucker' },
  { value: 'Cog', label: 'Zahnrad' },
  { value: 'ClipboardList', label: 'Aufgaben' },
  { value: 'Users', label: 'Personen' },
  { value: 'Phone', label: 'Telefon' },
  { value: 'Mail', label: 'Nachricht' },
  { value: 'Truck', label: 'Fahrzeug' },
] as const

export function useFeedbackSettings() {
  const { user } = useAuth()
  const api = useFeedbackApi()
  return useQuery({
    queryKey: ['feedback-settings'],
    queryFn: ({ signal }) => api.get<FeedbackSettings>('/einstellungen', { signal }),
    enabled: !!user,
    staleTime: 30_000,
  })
}

export function useSaveFeedbackSettings() {
  const api = useFeedbackApi()
  const client = useQueryClient()
  return useMutation({
    mutationFn: (settings: FeedbackSettings) => api.put('/einstellungen', settings),
    onSuccess: async () => {
      await Promise.all([
        client.invalidateQueries({ queryKey: ['feedback-settings'] }),
        client.invalidateQueries({ queryKey: ['feedback'] }),
      ])
    },
  })
}

export function feedbackCategoryKey(id: string) {
  return `kategorie:${id.toLowerCase()}`
}
